<template>
  <div :class="computedClasses">
    <tr-typography
      v-if="title"
      class="block bottom-offset2"
      variant="h3"
    >
      {{ title }}
    </tr-typography>
    <slot />
  </div>
</template>

<script>
import TrTypography from './TrTypography.vue';

export default {
  name: 'TrSlimbox',
  components: {
    TrTypography
  },
  props: {
    arrowDirection: {
      required: false,
      type: String
    },
    title: {
      required: false,
      type: String
    },
    size: {
      required: false,
      type: String,
      default: 'medium'
    },
    noMargin: {
      required: false,
      type: Boolean,
      default: false
    },
    withBorder: {
      required: false,
      type: Boolean,
      default: false
    },
    withDashedBorder: {
      required: false,
      type: Boolean,
      default: false
    },
    classes: {
      required: false,
      type: String,
      default: ''
    },
    withShadow: {
      required: false,
      type: Boolean,
      default: false
    },
    borderColor: {
      required: false,
      type: String,
      default: 'grey-light'
    }
  },
  computed: {
    computedClasses() {
      let classes = `slimbox slimbox--${this.size} border--${this.borderColor}`;

      if (!this.noMargin) {
        classes += ' bottom-offset3 ';
      }

      if (this.arrowDirection) {
        classes += ` arrow--${this.arrowDirection} `;
      }

      if (this.classes) {
        classes += ` ${this.classes} `;
      }

      if (this.withBorder) {
        classes += ' slimbox--border ';
      }

      if (this.withDashedBorder) {
        classes += ' slimbox--dashed-border ';
      }

      if (this.withShadow) {
        classes += ' slimbox--shadow ';
      }

      return classes;
    }
  }
};
</script>
